import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Card, Responsive } from 'rs-emd-ui-atoms';
import { getAttributes, getLabel } from '../../../helpers/html.utils';
import { ICategoryItem } from '../../../models/clp/category-item.model';
import { ILabel } from '../../../models/common/label.model';
import styles from './level-children-component.module.scss';

type LevelChildrenProps = {
  categories: ICategoryItem[];
  labels: ILabel[];
  onLevelClick?: () => void;
};

export const LevelChildren: FunctionComponent<LevelChildrenProps> = (props: LevelChildrenProps) => {
  return (
    <div className={styles['level-container']}>
      {props.categories.map((c) => {
        return (
          <Link
            to={c.url.url}
            {...getAttributes(c.url.attributes)}
            className={styles.cat}
            key={`hc-${c.id}`}
            onClick={() => props.onLevelClick && props.onLevelClick()}>
            {getContent(c)}
          </Link>
        );
      })}
    </div>
  );

  function getContent(category: ICategoryItem) {
    let content = (
      <>
        <div className={styles.details}>
          <h3 className={styles.title}>{category.url.text}</h3>

          <p className={styles['num-products']}>
            (
            {category.noOfChildren !== 0
              ? (category.noOfChildren ?? 0) > 1
                ? getLabel(props.labels, 'shop_categories').replace('[noOfChildren]', (category.noOfChildren ?? 0).toString())
                : getLabel(props.labels, 'shop_category')
              : (category.noOfProducts ?? 0) > 1
              ? getLabel(props.labels, 'shop_products').replace('[noOfProducts]', (category.noOfProducts ?? 0).toString())
              : getLabel(props.labels, 'shop_product')}
            )
          </p>
        </div>
        <div className={styles['img-container']}>
          <img alt={category.url.text} src={category.imageUrl} />
        </div>
      </>
    );

    return (
      <>
        <Responsive breakpoints={['mobile']}>
          <div key={`card-${category.id}`} className={styles['cat-card']}>
            {content}
          </div>
        </Responsive>
        <Responsive breakpoints={['tablet', 'desktop', 'lg-desktop', 'xl-desktop']}>
          <Card key={`card-${category.id}`} className={styles['cat-card']} radius={0}>
            {content}
          </Card>
        </Responsive>
      </>
    );
  }
};
